export const selectGohonzon = (state) => state.view_gohonzon;

export const selectMembersForGohonzonApply = (state) => {
  const gohonzon = selectGohonzon(state);
  return gohonzon.applyGohonzonList;
};

export const selectGohonzonType = (state) => {
  const gohonzon = selectGohonzon(state);
  return gohonzon.gohonzonType;
};

export const selectPaginationInfo = (state) => {
  const gohonzon = selectGohonzon(state);
  return gohonzon.paginationInfo;
};

export const gohonzonLoading = (state) => {
  const gohonzon = selectGohonzon(state);
  return gohonzon.isLoading;
};

export const selectOtp = (state) => {
  const gohonzon = selectGohonzon(state);
  return gohonzon.otp;
};

export const selectMemberIdForGohozonApply = (state) => {
  const gohonzon = selectGohonzon(state);
  return gohonzon.selectedMemberId;
};

export const selectGohozonVerification = (state) => {
  const gohonzon = selectGohonzon(state);
  return gohonzon.verificationList;
};

export const selectMemberForGohonzonApply = (state) => {
  const memberList = selectMembersForGohonzonApply(state);
  const selectedMemberId = selectMemberIdForGohozonApply(state);
  return (
    memberList?.find((member) => member.memberId === selectedMemberId) ?? {}
  );
};
